import React from 'react';
import NextLink from 'next/link';

import {buildUrl} from './build-url';
import {useAppRouter} from './router-context';
import {withSectionQuery} from './section-query';
import {RouteName, RouteParams} from './table';

export type LinkProps<K extends RouteName> = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
	route: K;
	params?: RouteParams<K>;
	prefetch?: boolean;
	/** переносить query текущего адреса при переходе внутри раздела; по умолчанию переносится */
	keepQuery?: boolean;
	children: React.ReactNode;
};

/**
 * Ссылка на именованный маршрут: `<Link route="class" params={{id}}>Бард</Link>`.
 */
const LinkWithRef = React.forwardRef<HTMLAnchorElement, LinkProps<RouteName>>(function Link(
	{route, params, prefetch, keepQuery = true, children, ...anchorProps},
	ref,
) {
	const router = useAppRouter();
	const href = buildUrl(route, keepQuery ? withSectionQuery(router?.asPath, route, params) : params);
	return (
		<NextLink href={href} prefetch={prefetch} ref={ref} {...anchorProps}>
			{children}
		</NextLink>
	);
});

/** forwardRef теряет дженерик маршрута, поэтому возвращаем его приведением типа */
export const Link = LinkWithRef as <K extends RouteName>(
	props: LinkProps<K> & {ref?: React.Ref<HTMLAnchorElement>},
) => React.ReactElement;
